/* Instance-scoped slideshow controls; keeps the original slideshow styling. */
(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-slideshow]').forEach(el => {
      if (el.dataset.initialized) return;
      el.dataset.initialized = 'true';
      const slides = Array.from(el.querySelectorAll('.slide'));
      if (slides.length < 2) return;
      const dots = Array.from(el.querySelectorAll('[data-slide-to]'));
      const pause = el.querySelector('[data-slide-pause]');
      const bar = el.querySelector('[data-slide-progress]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const duration = Math.max(3, Math.min(10, Number(el.dataset.autoplaySpeed) || 5)) * 1000;
      let current = 0, timer, focused = false, hovered = false;
      let paused = motion.matches || Boolean(window.Shopify && window.Shopify.designMode);
      function schedule() {
        clearTimeout(timer);
        if (bar) { bar.style.transition = 'none'; bar.style.width = '0%'; }
        pause.textContent = paused ? 'Play' : 'Pause';
        pause.setAttribute('aria-pressed', String(paused));
        if (paused || focused || hovered || document.hidden || !el.isConnected) return;
        if (bar) {
          void bar.offsetWidth;
          bar.style.transition = 'width ' + duration + 'ms linear';
          bar.style.width = '100%';
        }
        timer = setTimeout(() => goTo(current + 1), duration);
      }
      function goTo(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
          slide.toggleAttribute('inert', i !== current);
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === current);
          dot.setAttribute('aria-current', String(i === current));
        });
        schedule();
      }
      el.addEventListener('click', event => {
        const move = event.target.closest('[data-slide-move]');
        const to = event.target.closest('[data-slide-to]');
        if (move) goTo(current + Number(move.dataset.slideMove));
        if (to) goTo(Number(to.dataset.slideTo));
        if (event.target.closest('[data-slide-pause]')) { paused = !paused; schedule(); }
      });
      el.addEventListener('mouseenter', () => { hovered = true; schedule(); });
      el.addEventListener('mouseleave', () => { hovered = false; schedule(); });
      el.addEventListener('focusin', () => { focused = true; schedule(); });
      el.addEventListener('focusout', event => { focused = el.contains(event.relatedTarget); schedule(); });
      let startX = 0;
      el.addEventListener('touchstart', event => { startX = event.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', event => {
        const difference = startX - event.changedTouches[0].clientX;
        if (Math.abs(difference) > 50) goTo(current + (difference > 0 ? 1 : -1));
      }, { passive: true });
      document.addEventListener('visibilitychange', schedule);
      motion.addEventListener('change', event => { if (event.matches) paused = true; schedule(); });
      el.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-slide-index]');
        if (slide) { paused = true; goTo(Number(slide.dataset.slideIndex)); }
      });
      goTo(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
